import createClient from 'openapi-fetch';
import { localizedFetch } from '@/lib/apiClient';
import { getPersianErrorMessage } from '@/lib/persianUi';

const client = createClient({
    baseUrl: '/api/v1',
    credentials: 'include',
    fetch: localizedFetch,
});

// Throws Error(message) with .status on failure; returns data otherwise.
const unwrap = async (promise) => {
    const { data, error, response } = await promise;
    if (error) {
        const err = new Error(getPersianErrorMessage(error, 'خطای نامشخص.'));
        err.status = response?.status;
        throw err;
    }
    return data;
};

export const listRuleTypes = () =>
    unwrap(client.GET('/vendor/pricing/rule-types'));

export const getRule = (priceKind) =>
    unwrap(
        client.GET('/vendor/pricing/rules/{price_kind}', {
            params: { path: { price_kind: priceKind } },
        })
    );

export const saveRule = (priceKind, body) =>
    unwrap(
        client.PUT('/vendor/pricing/rules/{price_kind}', {
            params: { path: { price_kind: priceKind } },
            body,
        })
    );

export const deleteRule = (priceKind) =>
    unwrap(
        client.DELETE('/vendor/pricing/rules/{price_kind}', {
            params: { path: { price_kind: priceKind } },
        })
    );

export const previewPrice = (body) =>
    unwrap(client.POST('/vendor/pricing/preview', { body }));

export const listPrices = (priceKind, simulatorOnly = false) =>
    unwrap(
        client.GET('/vendor/pricing/prices/{price_kind}', {
            params: {
                path: { price_kind: priceKind },
                query: { simulator_only: simulatorOnly },
            },
        })
    );